<template>
    <div class="row">
        <div class="column">
            <div class="noBox"></div>
            <h1>{{$t('campaigns.noCampaign')}}</h1>
            <p v-if="$store.getters.USERPROFILE['campaign-administration']">{{$t('campaigns.beginCreateCampaign')}}</p>
            <router-link v-if="$store.getters.USERPROFILE['campaign-administration']" :to="{name: 'createCampaign'}">
                <button>
                    <i class="fas fa-plus"></i>
                    {{$t('button.createCoupon')}}
                </button>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return { }
        }
    }
</script>

<style scoped>
    .column {
        flex-grow: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: 100px;
        padding-top:100px;
    }
    h1,h2,p {
        padding: 12px 0px;
    }
    button {
        margin: 12px 0px;
    }
</style>